exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Custom, iPhone Retina */\n.fmcy-video-items.row-flex {\n  margin-left: 0;\n  margin-right: 0; }\n\n.fmcy-video-items .fmcy-video-item {\n  margin-bottom: 15px; }\n\n.fmcy-video-items .fmcy-video-item .fmcy-video-item-image {\n  height: 350px; }\n  @media only screen and (min-width: 991px) {\n    .fmcy-video-items .fmcy-video-item .fmcy-video-item-image.fmcy-video-item-image-large {\n      height: 700px; } }\n\n@media only screen and (min-width: 1600px) {\n  .fmcy-video-items .fmcy-video-item.fmcy-video-item-image {\n    height: 18vw; }\n    .fmcy-video-items .fmcy-video-item.fmcy-video-item-image.fmcy-video-item-image-large {\n      height: 36vw; } }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./assets/js/common/video-group/video-items/video-items.scss
 ** module id = 551
 ** module chunks = 1 16 107 119
 **/